// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomersSection_debt__3j6bx {
    width: 300px;
    padding: 1.25rem;
    background: white;
    border-radius: 10px;
}

.CustomersSection_deptHead__U2TH- {
    color: black;
    font-size: 18px;
    line-height: 32px;    
}

.CustomersSection_debtSum__VaY4b {
    color: brown;
    font-size: 32px;
    font-weight: bold;
}

.CustomersSection_filter__WVpBO {
    display: flex;
    align-items: center;
    padding: 16px;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 8px;
    margin: 1rem 0;
}

.CustomersSection_input__WzOUt {
  padding: 8px;
  margin-right: 1%;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid #ccc;
  transition: width 0.3s ease, opacity 0.3s ease, margin-right 0.3s ease;
  overflow: hidden;
}

.CustomersSection_filters__select__RQsvY {
  width: 21%;
  margin-right: 1%;
}


.CustomersSection_tableWrapper__KfC9L {
  max-height: 28vw; 
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

.CustomersSection_table__0dheY {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}
.CustomersSection_page__Ly-sD {
  color: red;
}
.CustomersSection_table__0dheY th,
.CustomersSection_table__0dheY td {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
  font-size: 14px;
}

.CustomersSection_table__0dheY th {
  background-color: #f9f9f9;
  font-weight: 600;
  color: #333;
}

.CustomersSection_table__0dheY tr:hover {
  background-color: #f5f5f5;
}

.CustomersSection_addCustomers__Sek9B {
  position: absolute;
  top: 2rem;
  right: 2rem;
  background: rgba(29, 135, 82, 1);
  color: white;
  padding: 5px 20px;
  border-radius: 5px;
  font-size: 25px;
}


`, "",{"version":3,"sources":["webpack://./src/styles/CustomersSection.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,wCAAwC;IACxC,kBAAkB;IAClB,cAAc;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,sEAAsE;EACtE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;;AAGA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".debt {\n    width: 300px;\n    padding: 1.25rem;\n    background: white;\n    border-radius: 10px;\n}\n\n.deptHead {\n    color: black;\n    font-size: 18px;\n    line-height: 32px;    \n}\n\n.debtSum {\n    color: brown;\n    font-size: 32px;\n    font-weight: bold;\n}\n\n.filter {\n    display: flex;\n    align-items: center;\n    padding: 16px;\n    background-color: rgba(255, 255, 255, 1);\n    border-radius: 8px;\n    margin: 1rem 0;\n}\n\n.input {\n  padding: 8px;\n  margin-right: 1%;\n  font-size: 14px;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  transition: width 0.3s ease, opacity 0.3s ease, margin-right 0.3s ease;\n  overflow: hidden;\n}\n\n.filters__select {\n  width: 21%;\n  margin-right: 1%;\n}\n\n\n.tableWrapper {\n  max-height: 28vw; \n  overflow-y: auto;\n  overflow-x: auto;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n}\n.page {\n  color: red;\n}\n.table th,\n.table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e0e0e0;\n  text-align: left;\n  font-size: 14px;\n}\n\n.table th {\n  background-color: #f9f9f9;\n  font-weight: 600;\n  color: #333;\n}\n\n.table tr:hover {\n  background-color: #f5f5f5;\n}\n\n.addCustomers {\n  position: absolute;\n  top: 2rem;\n  right: 2rem;\n  background: rgba(29, 135, 82, 1);\n  color: white;\n  padding: 5px 20px;\n  border-radius: 5px;\n  font-size: 25px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"debt": `CustomersSection_debt__3j6bx`,
	"deptHead": `CustomersSection_deptHead__U2TH-`,
	"debtSum": `CustomersSection_debtSum__VaY4b`,
	"filter": `CustomersSection_filter__WVpBO`,
	"input": `CustomersSection_input__WzOUt`,
	"filters__select": `CustomersSection_filters__select__RQsvY`,
	"tableWrapper": `CustomersSection_tableWrapper__KfC9L`,
	"table": `CustomersSection_table__0dheY`,
	"page": `CustomersSection_page__Ly-sD`,
	"addCustomers": `CustomersSection_addCustomers__Sek9B`
};
export default ___CSS_LOADER_EXPORT___;
